
import React from 'react';
import StatsCard from '../card/StatsCard';
import { DollarSign, Flame, Server, Building2 } from 'lucide-react';

interface GasCardsProps {
  isEditMode: boolean;
}

const GasCards: React.FC<GasCardsProps> = ({ isEditMode }) => {
  return (
    <>
      <StatsCard
        id="gas-cost"
        title="Total Gas Cost"
        value="$1,680"
        change="9.1% vs last month"
        isIncreasing={true}
        icon={<DollarSign className="h-6 w-6 text-purple-600" />}
        bgClass="bg-purple-50 dark:bg-purple-900/20"
        delay={800}
        isEditMode={isEditMode}
      />
      
      <StatsCard
        id="gas-consumption"
        title="Gas Consumption"
        value="240 m³"
        change="9.0% vs last month"
        isIncreasing={true}
        icon={<Flame className="h-6 w-6 text-purple-600" />}
        bgClass="bg-purple-50 dark:bg-purple-900/20"
        delay={900}
        isEditMode={isEditMode}
      />
      
      <StatsCard
        id="gas-devices"
        title="Gas Devices"
        value="95"
        change="3.2% vs last month"
        isIncreasing={true}
        icon={<Server className="h-6 w-6 text-purple-600" />}
        bgClass="bg-purple-50 dark:bg-purple-900/20"
        delay={1000}
        isEditMode={isEditMode}
      />
      
      <StatsCard
        id="gas-cost-facility"
        title="Gas Cost/Facility"
        value="$168"
        change="9.1% vs last month"
        isIncreasing={true}
        icon={<Building2 className="h-6 w-6 text-purple-600" />}
        bgClass="bg-purple-50 dark:bg-purple-900/20"
        delay={1100}
        isEditMode={isEditMode}
      />
    </>
  );
};

export default GasCards;
